import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Buy from '@/components/Buy';
import BuyBrowse from '@/components/BuyBrowse';
import ViewCategory from '@/components/ViewCategory';
import BuyCart from '@/components/BuyCart';
import BuySearch from '@/components/BuySearch';
import BuyAdvancedSearch from '@/components/BuyAdvancedSearch';
import Contact from '@/components/Contact';
import ClearCart from '@/components/ClearCart';
import Sell from '@/components/Sell';
import SellBrowse from '@/components/SellBrowse';
import SellViewCategory from '@/components/SellViewCategory';
import SellCart from '@/components/SellCart';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/buy',
      name: 'Buy',
      component: Buy,
      children: [
        {
          path: 'search',
          name: 'BuySearch',
          component: BuySearch,
        },
        {
          path: 'advanced-search',
          name: 'BuyAdvancedSearch',
          component: BuyAdvancedSearch,
        },
        {
          path: 'browse',
          name: 'Browse',
          component: BuyBrowse,
          children: [
            {
              path: ':id',
              name: 'ViewCategory',
              component: ViewCategory,
            },
          ],
        },
        {
          path: 'cart',
          name: 'Cart',
          component: BuyCart,
        },
      ],
    },
    {
      path: '/sell',
      name: 'Sell',
      component: Sell,
      children: [
        {
          path: 'browse',
          name: 'SellBrowse',
          component: SellBrowse,
          children: [
            {
              path: ':id',
              name: 'SellViewCategory',
              component: SellViewCategory,
            },
          ],
        },
        {
          path: 'cart',
          name: 'SellCart',
          component: SellCart,
        },
      ],
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/clear-cart',
      name: 'ClearCart',
      component: ClearCart,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js